import { isAuth0Enabled } from './auth.utils';
import { authReducer as authClassicReducer } from './auth-classic/auth-classic.reducer';
import { auth0Reducer } from './auth0/auth0.reducer';

export function authReducer(state, action) {
  return isAuth0Enabled()
    ? auth0Reducer(state, action)
    : authClassicReducer(state, action);
}
